import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiIconButton } from 'noddi-ui-web';
import { tracking } from 'noddi-web';
import { useCallback } from 'react';
import { openNoddiSupportWidget } from '../../../supportWidget/noddiSupportWidget';

export interface NavioContactChatWidgetProps {
  size?: 'small' | 'medium';
  className?: string;
}

export const NavioContactChatWidgetContent = ({ size = 'medium', className }: NavioContactChatWidgetProps) => {
  const triggerChat = useCallback(() => {
    tracking.track('helpScoutChatOpened');
    openNoddiSupportWidget();
  }, []);

  return (
    <div className={className}>
      {size === 'small' ? (
        <NoddiIconButton variant='outline' onClick={triggerChat} iconName='MessageSquare' aria-label={t`Chat`} />
      ) : (
        <NoddiButton startIcon='MessageSquare' variant='outline' onClick={triggerChat}>
          <Trans>Chat</Trans>
        </NoddiButton>
      )}
    </div>
  );
};
